import React from 'react';
import {observer} from 'mobx-react';
import {Route, Switch} from 'react-router-dom';
import DetailView from './DetailView';
import UnwatchedView from './UnwatchedView';
import {unwatchedMediaStore} from "../../store/MediaStore";
import CommonHelper from "../../helper/CommonHelper";
import qs from "qs";

let store = unwatchedMediaStore;

@observer
class UnwatchedViewFrame extends React.Component {

    componentDidMount() {
        let {location} = this.props;
        store.searchCondition.replace(CommonHelper.objectToMap(qs.parse(this.props.location.search, { ignoreQueryPrefix: true })));
        store.debounceRefresh()
    }


    componentWillUnmount() {
        store.clear()
    }

    render() {
        return (
            <Switch>
                <Route path="/main/home/:folderId/:fileId" component={DetailView}/>
                <Route path="/main/home" component={UnwatchedView}/>
            </Switch>
        );

    }
}

export default UnwatchedViewFrame;
